import request from '@/utils/httpClient'

// 获取列表
export function getCompanyContactList(params?: object) {
  return request({
    url: 'customerCompanyContact/page',
    method: 'get',
    params
  })
}

// 获取详情
export function getCompanyContactById(id: number) {
  return request({
    url: `customerCompanyContact/${id}`,
    method: 'get'
  })
}

// 批量删除
export function deleteCompanyContactById(id: number) {
  return request({
    url: `customerCompanyContact/${id}`,
    method: 'delete'
  })
}

// 设置默认联系人
export function setDefaultContact(id: number) {
  return request({
    url: `customerCompanyContact/${id}/actions/defaultContact`,
    method: 'put'
  })
}

/**
 *启用市场人员
 * @param id
 * @param data taxType  是否含税 api:/dropdown/TaxType
 * @param rateType 计算方式 按照百分比或者固定费用 api:/dropdown/RateType
 * @param rate 费用
 * @returns
 */
export function setAtionsMarket(id: number, data: object) {
  return request({
    url: `customerCompanyContact/${id}/actions/market`,
    method: 'put',
    data
  })
}

// 禁用市场人员
export function deleteAtionsMarket(id: number) {
  return request({
    url: `customerCompanyContact/${id}/actions/market`,
    method: 'delete'
  })
}
